import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function SocialVapingPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.socialVaping.heading')}
      buttons={[
        {
          text: t('pages.onboarding.socialVaping.options.always'),
          value: 'always',
        },
        {
          text: t('pages.onboarding.socialVaping.options.often-with-drinks'),
          value: 'often-with-drinks',
        },
        {
          text: t('pages.onboarding.socialVaping.options.sometimes'),
          value: 'sometimes',
        },
        {
          text: t('pages.onboarding.socialVaping.options.rarely-or-never'),
          value: 'rarely-or-never',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
